import Web3 from "web3";
import { ethers } from "ethers";
// Constant
import {
  getNetworkUrl,
  getContractDetails,
  getFeeCalucations,
} from "../helpers/constants";
//import NFTManagerabi from '../helpers/contracts/NFTOwnerManagerNew.json';
import NFTManagerabi from '../helpers/contracts/artifacts/NFTManager.json';
import PhysicalBuyabi from '../helpers/contracts/artifacts/PhysicalBuy.json';
// Utils
import * as Metamask from "./metamaskTransactions";
import * as WalletConnect from "./walletconnect";

class Web3Intraction {

  constructor(blockchain, walletType, settings) {
    const networkUrl = getNetworkUrl(blockchain || "ethereum", settings);
  // const _tokenContractAddress = "0xdfbaFB4D3d09Cb66C85C8bB6016E24e726663ed3";
  //   const _tokenmanagerContractAddress = "0x667dAF0feBb539F237F0c5a7678E81513a896255";
    //mainnet--
     const _tokenContractAddress= "0xB8367869967c34fA1F003717D035362c3f6cf1E1";
     const _tokenmanagerContractAddress= "0x48eaA1567506DE66CfAb5B8093cB7144cf247664";
    this.walletType = walletType;

    switch (walletType) {
      case "metamask":
        this.WALLET = Metamask;
        break;

      case "walletconnect":
        this.WALLET = WalletConnect;
        break;

      default:
        break;
    }

    this.settings = settings;
    this.adminContractSetting = getContractDetails(
      blockchain || "ethereum",
      settings
    );
    if (networkUrl) {
      this.networkUrl = networkUrl;
      this.web3 = new Web3(networkUrl.url);
      this._tokenContractAddress = _tokenContractAddress;
    }
    // console.log("yaha aa gye hum ", networkUrl);
  }

  isNetworkServiceWorking = () => {
    if (this.web3) {
      return true;
    }

    return false;
  };
  ismatic = async () => {
    // return new Promise(async (resolve, reject) => {
    return await window.ethereum.request({ method: 'net_version' })
      .then((networkId) => {
        //  Matic (Polygon) ID is '137'
        // console.log("networkId",networkId)
        if (networkId == '137') {
          return true;
        } else {
          // console.log("elsenetwork")
          return false
        }

      })
    // })

  }

  /**
   * Switch to network chain provided by Admin. It will automatic add new network if not added before.
   *
   * @returns {Promise} Resolve in Success or Error in Fail
   */
  switchChain = () => {
    return new Promise(async (resolve, reject) => {
      if (this.walletType !== "metamask") {
        const chainId = this?.WALLET.getCurrentChain();
        if (Number(this.networkUrl.chainId) != '137') {
          return reject(
            `Client error. Message from client: Config chainId=${this.networkUrl.chainId}, but wallet chainId=${chainId}`
          );
        }

        return resolve();
      }

      const params = {
        chainId: convertNumberToHex(this.networkUrl.chainId),
      };

      try {
        await this.WALLET.switchChain(params);

        resolve();
      } catch (error) {
        console.log("error", error);
        if (error.code === 4902) {
          (async () => {
            try {
              params.chainName = this.networkUrl.chainName;
              params.rpcUrls = [this.networkUrl.url];
              params.nativeCurrency = this.networkUrl.nativeCurrency;
              params.blockExplorerUrls = this.networkUrl.blockExplorerUrls;
              await this.WALLET.addChain(params);
              resolve();
            } catch (error2) {
              console.log("add network failed", error2);
              reject(error2);
            }
          })();
        } else {
          reject(error);
        }
      }
    });
  };

  convertPriceToEther = (price) => {
    return ethers.utils.parseEther(Number(price).toFixed(8))._hex;
    // return Web3.utils.toWei(Number(price).toFixed(8), "ether")
  };

  getContract = (abi, address) => {
    try {
      let contract = new this.web3.eth.Contract(JSON.parse(abi), address);

      return contract;
    } catch (error) {
      console.log("error", error);
      return null;
    }
  };

  eth_sendTransaction = (params, getToken) => {
    return new Promise(async (resolve, reject) => {
      try {
        const txHash = await this.WALLET.sendTransaction(params);

        let receipt = await this.getTransactionReceipt(txHash, getToken);
        resolve({ txHash, receipt });
      } catch (error) {
        reject(error);
      }
    });
  };

  getTransactionReceipt = (transactionHash, getToken) => {
    return new Promise(async (resolve, reject) => {
      this.contractInterval = setInterval(async () => {
        try {
          let receipt = await this.web3.eth.getTransactionReceipt(
            transactionHash
          );

          console.log("final receipt", receipt);

          if (!!receipt) {
            if (getToken && !!receipt?.logs && !!receipt.logs[0]) {
              receipt.token_id = this.web3.utils.hexToNumberString(
                receipt.logs[0].topics[3]
              );
            }

            clearInterval(this.contractInterval);
            this.contractInterval = null;

            resolve(receipt);
          }
        } catch (error) {
          clearInterval(this.contractInterval);
          this.contractInterval = null;

          reject(error);
        }
      }, 15000);
    });
  };

  /**
   * Deploy collection contract.
   *
   * @param {string} userWallet Current user wallet address
   * @param {object} collectionData Collection Details (ie. abi, bytecode)
   * @param {function} callback Callback function
   *
   * @returns {Promise} Object (Transaction Hash, Contract Address) in Success or Error in Fail
   */
  deployContract = (userWallet, collection, callback) => {
    return new Promise(async (resolve, reject) => {
      //set up transaction parameters
      const transactionParameters = {
        from: userWallet, // must match user's active address.
        data: collection.data.bytecode,
      };

      try {
        let receipt = await this.eth_sendTransaction(transactionParameters);

        callback && callback(null, receipt);
        resolve(receipt);
      } catch (error) {
        callback && callback(error.message);
        reject(error.message);
      }
    });
  };

  /**
   * Check user approved contract transactions, if not then make transaction to approve.
   *
   * @param {string} userWallet Current user wallet address
   * @param {object} collectionData Collection Details (ie. abi, contract address, bytecode)
   * @param {function} callback Callback function
   *
   * @returns {Promise} Success for approved or Fail for error
   */
  verifyApproved = (userWallet, collection, callback) => {
    return new Promise(async (resolve, reject) => {
      if (collection.abi && collection.data.contractAddress) {
        const contract = this.getContract(
          collection.abi,
          collection.data.contractAddress
        );

        if (!contract) {
          const error_message = "Invalid Contract";
          callback && callback(error_message);
          reject(error_message);
          return;
        }

        const isApproved = await contract.methods
          .isApprovedForAll(userWallet, this.settings.walletAddress.publicKey)
          .call();

        if (isApproved) {
          callback && callback(null, collection);
          resolve(collection);
          return;
        }

        const transactionParameters = {
          to: collection.data.contractAddress, // Required except during contract publications.
          from: userWallet, // must match user's active address.
          data: contract.methods
            .setApprovalForAll(this.settings.walletAddress.publicKey, true)
            .encodeABI(),
        };

        try {
          let { receipt } = await this.eth_sendTransaction(
            transactionParameters
          );

          callback && callback(null, receipt);
          resolve(receipt);
        } catch (error) {
          callback && callback(error.message);
          reject(error.message);
        }
      } else {
        const error_message = "No Collection Data!";
        callback && callback(error_message);
        reject(error_message);
      }
    });
  };

  /**
   * Mint NFT
   *
   * @param {string} userWallet Current user wallet address
   * @param {object} collectionData Collection Details (ie. abi, contract address, bytecode)
   * @param {object} itemData (NFT) Item details
   * @param {function} callback Callback function
   *
   * @returns {Promise} Receipt in Success or Error in Fail
   */
  
  newMintNFT = async (wallAddress, data) => {
    const networkUrl_local= 'https://polygon-amoy.infura.io/v3/ec44a60863824a72ba2927219bbd96f0';
    const nftManagerAddress_local= "0x667dAF0feBb539F237F0c5a7678E81513a896255";
    const networkUrl = 'https://polygon-mainnet.infura.io/v3/bd0a62533626412ab146eadc3e7d495f';
    const nftManagerAddress = "0x48eaA1567506DE66CfAb5B8093cB7144cf247664";
  
    if (typeof window.ethereum === "undefined" || !window.ethereum.isMetaMask) {
     
      return { status: false, message: "MetaMask is not installed." };
    }
  
    try {
      // Initialize MetaMask provider and web3
      const provider = window.ethereum;
      await provider.request({ method: 'eth_requestAccounts' });
      const userAddress = provider.selectedAddress;
      if (!userAddress) {
        throw new Error("No wallet address found. Please connect MetaMask.");
      }
  
      const web3 = new Web3(new Web3.providers.HttpProvider(networkUrl));
      const contract = new web3.eth.Contract(NFTManagerabi.abi, nftManagerAddress);
  
  
       // Encode the mintNFT method call
       const encodedData = contract.methods
       .mintNFT(
         data?.copies,                 // uint256 amount
         data?.category,               // string category
         data?.name,                   // string name
         userAddress,                  // address creator
         data?.royaltyPercentage,      // uint256 royaltyPercentage
         data?.hash ,                   // string hash
         data?.copies
       ).encodeABI();
      


     // Estimate gas
     const gasEstimate = await web3.eth.estimateGas({
       to: nftManagerAddress,
       from: userAddress,
       data: encodedData,
     });

     const gasPrice = await web3.eth.getGasPrice();

     // Build transaction parameters
     const transactionParameters = {
       to: nftManagerAddress,        // Contract address
       from: userAddress,            // User's wallet address
       data: encodedData,            // Encoded mintNFT method
       gas: web3.utils.toHex(gasEstimate), // Estimated gas limit
       gasPrice: web3.utils.toHex(gasPrice), // Current gas price
     };

     

     // Send transaction via MetaMask
     const txHash = await provider.request({
       method: 'eth_sendTransaction',
       params: [transactionParameters],
     });
  
  
      // Poll for receipt
      const receipt = await pollTransactionReceipt(web3, txHash);
      if (!receipt || !receipt.status) {
        console.error("Transaction failed:", receipt);
        return { status: false,
                    transHash: txHash,
                    tokenId: "0",
                    message: 'Transaction failed!' };
      }
  
 
  
      // Extract token ID from logs
      const tokenId = web3.utils.hexToNumber(receipt.logs[1]?.data || "0x0");
      return {
        status: true,
        message: "Digital Artwork minted successfully!",
        transHash: txHash,
        trans_Hash: txHash,
        to: receipt.to,
         from: receipt.from,
        tokenId: tokenId,
      };
     
  
    } catch (error) {
      console.error("Error during minting:", error);
      return { status: false,
                transHash: null,
                tokenId: "0",
                message: 'Something went wrong!' 
              };
    }
  };
  activeAuction = async (wallAddress, data) => {
     const networkUrl_local= 'https://polygon-amoy.infura.io/v3/ec44a60863824a72ba2927219bbd96f0';
    const nftManagerAddress_local= "0x667dAF0feBb539F237F0c5a7678E81513a896255";
    const networkUrl = 'https://polygon-mainnet.infura.io/v3/bd0a62533626412ab146eadc3e7d495f';
    const nftManagerAddress = "0x48eaA1567506DE66CfAb5B8093cB7144cf247664";
  
     
  // Check if MetaMask or Ethereum provider is available
  if (typeof window.ethereum === "undefined" || !window.ethereum.isMetaMask) {
    console.warn("Please use a dapp browser like mist or MetaMask plugin for chrome");
    return { status: false, transHash: null, message: "Please use a dapp browser like mist or MetaMask plugin for chrome" };
  }

  try {
    const provider = window.ethereum;
    await provider.enable();

    const web3 = new Web3(new Web3.providers.HttpProvider(networkUrl));
    const contract = new web3.eth.Contract(NFTManagerabi.abi, nftManagerAddress);
    const userAddress = provider.selectedAddress;

    // Calculate the total price
    const decimals = web3.utils.toBN(18);
    let totalPrice;
    
    if (Number(data?.price) > 999) {
      totalPrice = web3.utils.toBN(data?.price).mul(web3.utils.toBN(10).pow(decimals));
    } else {
      totalPrice = web3.utils.toHex(web3.utils.toWei(data?.price, 'ether'));
    }
// console.log("hawa ha ",data?.token+ " 1 "+ userAddress+" 2 "+ totalPrice+" 3 "+data?.auctionduration)
    // Transaction parameters
    const transactionParameters = {
      to: nftManagerAddress,
      from: userAddress,
      data: contract.methods
        .startAuction(data?.token, userAddress, totalPrice, data?.auctionduration)
        .encodeABI(),
    };

    // Send transaction
    const transactionHash = await provider.request({
      method: "eth_sendTransaction",
      params: [transactionParameters],
    });
// console.log("hawwwwwwwww ",transactionHash)
    // Polling for transaction receipt
    const receipt = await pollTransactionReceipt(web3, transactionHash);
    if (receipt.status) {
      const timeStamp = (await web3.eth.getBlock(receipt.blockNumber)).timestamp;
      return {
        status: true,
        timeStamp,
        transHash: receipt.transactionHash,
        message: "Successfully auction activated!!!",
      };
    } else {
      return { status: false, transHash: receipt, message: "Auction activation failed" };
    }
  } catch (error) {
    console.error("Something went wrong:", error);
    return { status: false, transHash: error, message: "Something went wrong" };
  }
};


  placeBid = async (wallAddress, data) => {
     const networkUrl_local= 'https://polygon-amoy.infura.io/v3/ec44a60863824a72ba2927219bbd96f0';
    const nftManagerAddress_local= "0x667dAF0feBb539F237F0c5a7678E81513a896255";
    const networkUrl = 'https://polygon-mainnet.infura.io/v3/bd0a62533626412ab146eadc3e7d495f';
    const nftManagerAddress = "0x48eaA1567506DE66CfAb5B8093cB7144cf247664";
  

    if (typeof window.ethereum !== "undefined" &&
      window.ethereum.isMetaMask
    ) {
      let provider = window["ethereum"];
      await provider.enable();
      let myProvider = new Web3.providers.HttpProvider(networkUrl);
      const web3 = new Web3(myProvider);
      let contract = await new web3.eth.Contract(
        NFTManagerabi.abi, nftManagerAddress
      );
      let userAddress = provider.selectedAddress;
      const decimals = web3.utils.toBN(18);
      let Totalprice;
      if (Number(data?.price) > 999) {
        const tokenAmount = web3.utils.toBN(data?.bidamount);
        Totalprice = web3.utils.toHex(tokenAmount.mul(web3.utils.toBN(10).pow(decimals)));

      } else {
        Totalprice = web3.utils.toHex(web3.utils.toWei(data?.bidamount, 'ether'))

      }
      const transactionParameters = {
        to: nftManagerAddress,
        from: userAddress,
        value: Totalprice,
        'data': contract.methods.placeBid(data?.tokenId, Totalprice, userAddress).encodeABI()
      };
      return await window.ethereum
        .request({
          method: 'eth_sendTransaction',
          params: [transactionParameters],
        }).then(async (result) => {
          var p1 = new Promise((resolve) => {
            const interval = setInterval(() => {
              web3.eth.getTransactionReceipt(result, (err, rec) => {
                if (rec) {
                  clearInterval(interval);
                  resolve(rec);
                }
              });
            }, 1000)


          });
          return p1.then(async (res) => {
            if (res.status) {
              const res1 = { ...res, ...result }
              return { status: true, transHash: res, trans_Hash: res.transactionHash, message: 'Successfully bid submitted' };

            } else {
              return { status: false, transHash: res, trans_Hash: "", message: 'bid not submitted.' };
            }
          })

        }).catch((error) => {
          console.log("Something went wrong: " + error.message);
          return { status: false, transHash: error, trans_Hash: "", message: 'Something went wrong' };
        })
    } else {
      console.warn(
        'Please use a dapp browser like mist or MetaMask plugin for chrome'
      );
      return { status: false, transHash: null, trans_Hash: "", message: 'Please use a dapp browser like mist or MetaMask plugin for chrome' };
    }
  }
  activeSell = async (wallAddress,data) => {
     const networkUrl_local= 'https://polygon-amoy.infura.io/v3/ec44a60863824a72ba2927219bbd96f0';
    const nftManagerAddress_local= "0x667dAF0feBb539F237F0c5a7678E81513a896255";
    const networkUrl = 'https://polygon-mainnet.infura.io/v3/bd0a62533626412ab146eadc3e7d495f';
    const nftManagerAddress = "0x48eaA1567506DE66CfAb5B8093cB7144cf247664";
  
  
    if (typeof window.ethereum === "undefined" || !window.ethereum.isMetaMask) {
      console.warn("Please use a dApp browser like MetaMask.");
      return { status: false, message: "MetaMask is not available!" };
    }
  
    try {
       // Initialize MetaMask provider and web3
       const provider = window.ethereum;
       await provider.request({ method: 'eth_requestAccounts' });
       const userAddress = provider.selectedAddress;
       if (!userAddress) {
         throw new Error("No wallet address found. Please connect MetaMask.");
       }
   
       const web3 = new Web3(new Web3.providers.HttpProvider(networkUrl));
       const contract = new web3.eth.Contract(NFTManagerabi.abi, nftManagerAddress);
   
      console.log("data sell active ",data)
      // Encode the sellNFT method call
      const encodedData = contract.methods.sellNFT(data?.token).encodeABI();
  
      // Estimate gas
      const gasEstimate = await web3.eth.estimateGas({
        to: nftManagerAddress,
        from: userAddress,
        data: encodedData,
      });
  
      const gasPrice = await web3.eth.getGasPrice();
  
      // Transaction parameters
      const transactionParameters = {
        to: nftManagerAddress,
        from: userAddress,
        data: encodedData,
        gas: web3.utils.toHex(gasEstimate),
        gasPrice: web3.utils.toHex(gasPrice),
      };
  
      console.log("Transaction Parameters:", transactionParameters);
  
      // Send transaction via MetaMask
      const txHash = await provider.request({
        method: "eth_sendTransaction",
        params: [transactionParameters],
      });
  
      console.log("Transaction sent! Hash:", txHash);
  
      // Wait for the transaction receipt
      const receipt = await pollTransactionReceipt(web3, txHash);
      if (receipt.status) {
        console.log("Transaction successful! Receipt:", receipt);
        return { status: true, transHash: txHash, message: "Successfully activated sell!" };
      } else {
        console.error("Transaction failed! Receipt:", receipt);
        return { status: false, transHash: txHash, message: "Sell activation failed!" };
      }
    } catch (error) {
      console.error("Transaction Error:", error.message);
      return { status: false,transHash:'', message: "Something went wrong!", error: error.message };
    }
  };

  
  buyPhysicalNFT = async (wallAddress, data) => {
   
    const networkUrl_local = 'https://polygon-amoy.infura.io/v3/ec44a60863824a72ba2927219bbd96f0';
    const PhysicalBuy_local = "0x4cD650033020c857F9780aDdf1507fD7F45c24fC";
    const networkUrl= 'https://polygon-mainnet.infura.io/v3/bd0a62533626412ab146eadc3e7d495f';
    const PhysicalBuy = "0x209DA4B79B87D86DeFFd067eC83F2B15ef4Be470";
    if (
      typeof window.ethereum !== "undefined" &&
      window.ethereum.isMetaMask
    ) {
      let provider = window["ethereum"];
      await provider.enable();
      let myProvider = new Web3.providers.HttpProvider(networkUrl);
      const web3 = new Web3(myProvider);
      let contract = await new web3.eth.Contract(
        PhysicalBuyabi.abi, PhysicalBuy
      );
      let userAddress = provider.selectedAddress;
      const decimals = web3.utils.toBN(18);
      let Totalprice;
      let phOwnerAmount = 0;
      let phAdminAmount = 0;
      if (Number(data?.totalAmount) > 999) {
  const tokenAmount = web3.utils.toWei((Number(data?.totalAmount) + 0.00001).toString(), 'ether');
  Totalprice = web3.utils.toHex(tokenAmount);
} else {
  Totalprice = web3.utils.toHex(web3.utils.toWei((Number(data?.totalAmount) + 0.00001).toString(), 'ether'));
} 


  if (Number(data?.calamount) > 999) {
  const phadmintokenAmount = web3.utils.toWei(Number(data?.calamount).toString(), 'ether');
  phAdminAmount = web3.utils.toHex(phadmintokenAmount);
} else {
  phAdminAmount = web3.utils.toHex(web3.utils.toWei(Number(data?.calamount).toString(), 'ether'));
}


   if (Number(data?.physicalOwnerAmount) > 999) {
  const phtokenAmount = web3.utils.toWei(Number(data?.physicalOwnerAmount).toString(), 'ether');
  phOwnerAmount = web3.utils.toHex(phtokenAmount);
} else {
  phOwnerAmount = web3.utils.toHex(web3.utils.toWei(Number(data?.physicalOwnerAmount).toString(), 'ether'));
}
      // if (Number(data?.totalAmount) > 999) {
      //   const tokenAmount = web3.utils.toBN(Number(data?.totalAmount + 0.00001).toString());
      //  const finalprice = tokenAmount.mul(web3.utils.toBN(10).pow(decimals));
      //   Totalprice = web3.utils.toHex(finalprice);
      //  } else {
      //   Totalprice = web3.utils.toHex(web3.utils.toWei(Number(data?.totalAmount + 0.00001).toString(), 'ether'));
      //  }

      // if (Number(data?.calamount) > 999) {
      // const phadmintokenAmount = web3.utils.toBN(Number(data?.calamount).toString());
      //   phAdminAmount = web3.utils.toHex(phadmintokenAmount.mul(web3.utils.toBN(10).pow(decimals)));
       
      // } else {
      //  phAdminAmount = web3.utils.toHex(web3.utils.toWei(Number(data?.calamount).toString(), 'ether'))
      // }

      // if (Number(data?.physicalOwnerAmount) > 999) {
      //  const phtokenAmount = web3.utils.toBN((data?.physicalOwnerAmount).toString());
      //   phOwnerAmount = web3.utils.toHex(phtokenAmount.mul(web3.utils.toBN(10).pow(decimals)));
      // } else {
      //   phOwnerAmount = web3.utils.toHex(web3.utils.toWei((data?.physicalOwnerAmount).toString(), 'ether'))
      // }
    //  console.log("hello",Totalprice,phAdminAmount,phOwnerAmount)
      const transactionParameters = {
        to: PhysicalBuy, // Required except during contract publications.
        from: userAddress, // must match user's active address.
        value: Totalprice,
        'data': contract.methods.buyNFTPhysical(data?.owner,phAdminAmount,phOwnerAmount).encodeABI() //make call to NFT smart contract
      };
      //sign transaction via Metamask
      return await window.ethereum
        .request({
          method: 'eth_sendTransaction',
          params: [transactionParameters],
        }).then(async (result) => {
          var p1 = new Promise((resolve) => {
            const interval = setInterval(() => {
              console.log("Attempting to get transaction receipt...");
              web3.eth.getTransactionReceipt(result, (err, rec) => {
                if (rec) {
                  console.log(rec);
                  // return { status: true, transHash: result, message: 'Successfully minted!!!' };
                  clearInterval(interval);
                  resolve(rec);
                }
              });
            }, 1000)
          });
          return p1.then(async (res) => {
            if (res.status) {
              const res1 = { ...res, ...result }
              return { status: true, transHash: res1, trans_Hash: res.transactionHash, message: 'Successfully place order for Physical art' };
            } else {
              return { status: false, transHash: res, trans_Hash: "", message: 'Order not submitted.' };
            }
          })
        }).catch((error) => {
          console.log("Something went wrong: " + error.message);
          return { status: false, transHash: error, trans_Hash: "", message: 'Something went wrong' };
        })
    } else {
      console.warn(
        'Please use a dapp browser like mist or MetaMask plugin for chrome'
      );
      return { status: false, transHash: null, trans_Hash: "", message: 'Please use a dapp browser like mist or MetaMask plugin for chrome' };
    }
  }
  buyNFT = async (wallAddress, data) => {
    const networkUrl_local= 'https://polygon-amoy.infura.io/v3/ec44a60863824a72ba2927219bbd96f0';
    const nftManagerAddress_local= "0x667dAF0feBb539F237F0c5a7678E81513a896255";
    const networkUrl = 'https://polygon-mainnet.infura.io/v3/bd0a62533626412ab146eadc3e7d495f';
    const nftManagerAddress = "0x48eaA1567506DE66CfAb5B8093cB7144cf247664";
  
    if (
      typeof window.ethereum !== "undefined" &&
      window.ethereum.isMetaMask
    ) {
      let provider = window["ethereum"];
      await provider.enable();
      let myProvider = new Web3.providers.HttpProvider(networkUrl);
      const web3 = new Web3(myProvider);
      let contract = await new web3.eth.Contract(
        NFTManagerabi.abi, nftManagerAddress
      );
      let userAddress = provider.selectedAddress;
      const decimals = web3.utils.toBN(18);

      let Totalprice;
      let price = web3.utils.toHex(web3.utils.toWei((data?.salePrice).toString(), 'ether'));
      let calamount;
      if (Number(data?.dtamount) > 0) {
        calamount = Number(data?.buyamount) * Number(data?.salePrice) - Number(data?.dtamount) + 0.00001;
      } else {
        calamount = Number(data?.buyamount) * Number(data?.salePrice);
      }

      if (Number(calamount) > 999) {
        const tokenAmount = web3.utils.toBN(calamount.toString());

        const finalprice = tokenAmount.mul(web3.utils.toBN(10).pow(decimals));
        Totalprice = web3.utils.toHex(finalprice);

      } else {
        Totalprice = web3.utils.toHex(web3.utils.toWei(calamount.toFixed(6), 'ether'))

      }
      let dtamount = 0;
      let dtnftowneramount = 0;

      if (Number(data?.dtamount) > 0) {
        if (Number(data?.dtamount) > 999) {
          const tokenAmount = web3.utils.toBN((data?.dtamount).toString());
          dtamount = web3.utils.toHex(tokenAmount.mul(web3.utils.toBN(10).pow(decimals)));
        } else {
          dtamount = web3.utils.toHex(web3.utils.toWei((data?.dtamount).toString(), 'ether'))
        }
      }

      if (Number(data?.dtnftowneramount) > 0) {
        if (Number(data?.dtnftowneramount) > 999) {
          const tokenAmount = web3.utils.toBN((data?.dtnftowneramount).toString());
          dtnftowneramount = web3.utils.toHex(tokenAmount.mul(web3.utils.toBN(10).pow(decimals)));
        } else {
          dtnftowneramount = web3.utils.toHex(web3.utils.toWei((data?.dtnftowneramount).toString(), 'ether'))
        }

      }
      const transactionParameters = {
        to: nftManagerAddress, // Required except during contract publications.
        from: userAddress, // must match user's active address.
        value: Totalprice,
        'data': contract.methods.buyNFT(data?.owner, data?.tokenId, price, data?.buyamount, data?.dt, dtamount, data?.dtnftowner, dtnftowneramount).encodeABI() //make call to NFT smart contract
      };
      //sign transaction via Metamask
      return await window.ethereum
        .request({
          method: 'eth_sendTransaction',
          params: [transactionParameters],
        }).then(async (result) => {
          var p1 = new Promise((resolve) => {
            const interval = setInterval(() => {
              console.log("Attempting to get transaction receipt...");

              web3.eth.getTransactionReceipt(result, (err, rec) => {
                if (rec) {
                  console.log(rec);
                  // return { status: true, transHash: result, message: 'Successfully minted!!!' };
                  clearInterval(interval);
                  resolve(rec);
                }
              });
            }, 1000)


          });
          return p1.then(async (res) => {
            if (res.status) {
              const res1 = { ...res, ...result }
              return { status: true, transHash: res1, trans_Hash: res.transactionHash, message: 'Successfully bid submitted' };

            } else {
              return { status: false, transHash: res, trans_Hash: "", message: 'bid not submitted.' };
            }
          })

        }).catch((error) => {
          console.log("Something went wrong: " + error.message);
          return { status: false, transHash: error, trans_Hash: "", message: 'Something went wrong' };
        })
    } else {
      console.warn(
        'Please use a dapp browser like mist or MetaMask plugin for chrome'
      );
      return { status: false, transHash: null, trans_Hash: "", message: 'Please use a dapp browser like mist or MetaMask plugin for chrome' };
    }
  }
  resellNFT = async (wallAddress, data) => {
     const networkUrl_local= 'https://polygon-amoy.infura.io/v3/ec44a60863824a72ba2927219bbd96f0';
    const nftManagerAddress_local= "0x667dAF0feBb539F237F0c5a7678E81513a896255";
    const networkUrl = 'https://polygon-mainnet.infura.io/v3/bd0a62533626412ab146eadc3e7d495f';
    const nftManagerAddress = "0x48eaA1567506DE66CfAb5B8093cB7144cf247664";
  

    if (
      typeof window.ethereum !== "undefined" &&
      window.ethereum.isMetaMask
    ) {
      let provider = window["ethereum"];
      await provider.enable();
      let myProvider = new Web3.providers.HttpProvider(networkUrl);
      const web3 = new Web3(myProvider);
      let contract = await new web3.eth.Contract(
        NFTManagerabi.abi, nftManagerAddress
      );
      let userAddress = provider.selectedAddress;

      let listingprice;

      // salePrice =  web3.utils.toHex(web3.utils.toWei(data?.listingprice, 'ether'))
      listingprice = web3.utils.toHex(web3.utils.toWei(data?.listingprice, 'ether'));
      console.log("minting data ", "creator => " + data?.creator, "tokenId => " + data?.tokenId, "saleprice (pricepercopy) => " + listingprice, "royality => " + data?.royality, "copiesTosell => " + data?.copiesTosell, "listingprice => " + data?.listingprice)
      const transactionParameters = {
        to: nftManagerAddress, // Required except during contract publications.
        from: userAddress, // must match user's active address.
        value: listingprice,
        'data': contract.methods.resellNFT(data?.tokenId, listingprice, data?.creator, data?.royality, data?.copiesTosell).encodeABI() //make call to NFT smart contract
      };
      //sign transaction via Metamask
      return await window.ethereum
        .request({
          method: 'eth_sendTransaction',
          params: [transactionParameters],
        }).then(async (result) => {


          // console.log("Transaction sent!", result);

          var p1 = new Promise((resolve) => {
            const interval = setInterval(() => {
              console.log("Attempting to get transaction receipt...");

              web3.eth.getTransactionReceipt(result, (err, rec) => {
                if (rec) {
                  console.log(rec);
                  // return { status: true, transHash: result, message: 'Successfully minted!!!' };
                  clearInterval(interval);
                  resolve(rec);
                }
              });
            }, 1000)


          });

          return p1.then(async (res) => {
            if (res.status) {
              const res1 = { ...res, ...result }
              return { status: true, transHash: res1, message: 'resell Digital Artwork submitted' };

            } else {
              return { status: false, transHash: res, message: 'resell not submitted.' };
            }
          })

        }).catch((error) => {
          console.log("Something went wrong: " + error.message);
          return { status: false, transHash: error, message: 'Something went wrong' };
        })
    } else {
      console.warn(
        'Please use a dapp browser like mist or MetaMask plugin for chrome'
      );
      return { status: false, transHash: null, message: 'Please use a dapp browser like mist or MetaMask plugin for chrome' };
    }
  }

  resoldbuyNFT = async (wallAddress, data) => {
    const networkUrl_local= 'https://polygon-amoy.infura.io/v3/ec44a60863824a72ba2927219bbd96f0';
    const nftManagerAddress_local= "0x667dAF0feBb539F237F0c5a7678E81513a896255";
    const networkUrl = 'https://polygon-mainnet.infura.io/v3/bd0a62533626412ab146eadc3e7d495f';
    const nftManagerAddress = "0x48eaA1567506DE66CfAb5B8093cB7144cf247664";
  
    if (
      typeof window.ethereum !== "undefined" &&
      window.ethereum.isMetaMask
    ) {
      let provider = window["ethereum"];
      await provider.enable();
      let myProvider = new Web3.providers.HttpProvider(networkUrl);
      const web3 = new Web3(myProvider);
      let contract = await new web3.eth.Contract(
        NFTManagerabi.abi, nftManagerAddress
      );
      let userAddress = provider.selectedAddress;
      const decimals = web3.utils.toBN(18);
      let Totalprice;
      let salePrice;
      if (Number(data?.salePrice) > 999) {
        const tokenAmount = web3.utils.toBN(data?.salePrice);
        salePrice = tokenAmount.mul(web3.utils.toBN(10).pow(decimals));
        Totalprice = web3.utils.toHex((data?.buyamount) * salePrice);

      } else {
        salePrice = web3.utils.toHex(web3.utils.toWei(data?.salePrice, 'ether'))
        Totalprice = (data?.buyamount) * salePrice;
      }

     
      const transactionParameters = {
        to: nftManagerAddress, // Required except during contract publications.
        from: userAddress, // must match user's active address.
        value: Totalprice,
        'data': contract.methods.resoldbuyNFT(data?.owner, data?.tokenId, salePrice, data?.buyamount).encodeABI() //make call to NFT smart contract
      };
      //sign transaction via Metamask
      return await window.ethereum
        .request({
          method: 'eth_sendTransaction',
          params: [transactionParameters],
        }).then(async (result) => {

          var p1 = new Promise((resolve) => {
            const interval = setInterval(() => {
              console.log("Attempting to get transaction receipt...");

              web3.eth.getTransactionReceipt(result, (err, rec) => {
                if (rec) {
                  // return { status: true, transHash: result, message: 'Successfully minted!!!' };
                  clearInterval(interval);
                  resolve(rec);
                }
              });
            }, 1000)


          });
          return p1.then(async (res) => {
            if (res.status) {
              const res1 = { ...res, ...result }
              return { status: true, transHash: res1, message: 'resell nft bought' };

            } else {
              return { status: false, transHash: res, message: 'resell buy not bought.' };
            }
          })

        }).catch((error) => {
          console.log("Something went wrong: " + error.message);
          return { status: false, transHash: error, message: 'Something went wrong' };
        })
    } else {
      console.warn(
        'Please use a dapp browser like mist or MetaMask plugin for chrome'
      );
      return { status: false, transHash: null, message: 'Please use a dapp browser like mist or MetaMask plugin for chrome' };
    }
  }


  /**
   * Transfer balance to NFT owner account
   *
   * @param {string} userWallet Current user wallet address
   * @param {object} itemData (NFT) Item details
   * @param {function} callback Callback function
   *
   * @returns {Promise} Receipt in Success or Error in Fail
   */
  sendTransaction = (userWallet, item, callback) => {
    return new Promise(async (resolve, reject) => {
      const adminContract = this.getContract(
        JSON.stringify(this.adminContractSetting.abi),
        this.adminContractSetting.contractAddress
      );

      let data = {
        address: [
          "0x25F7403A9Ed9166A8E403C66D0a931665ebe8b77",
          "0xbB1A2c73BA1b77748C9fBadCA03e4A2e1a104D64",
        ],
        price: ["0x5aee68627800", "0x04a817c800"],
      };
      const calculatePrice = getFeeCalucations(item, this.settings);
      const transactionParameters = {
        to: this.adminContractSetting.contractAddress, // Required except during contract publications.
        from: userWallet, // must match user's active address.
        value: this.convertPriceToEther(item.price.toString()),
        data: adminContract.methods
          .sendETH(calculatePrice.address, calculatePrice.price)
          .encodeABI(),
      };

      try {
        let { receipt } = await this.eth_sendTransaction(transactionParameters);

        callback && callback(null, receipt);
        resolve(receipt);
      } catch (error) {
        callback && callback(error);
        reject(error);
      }
    });
  };
}

export default Web3Intraction;

  // Helper function to poll for transaction receipt
  const pollTransactionReceipt = (web3, txHash) => {
    return new Promise((resolve, reject) => {
      const interval = setInterval(async () => {
        try {
          const receipt = await web3.eth.getTransactionReceipt(txHash);
          if (receipt) {
            clearInterval(interval);
            resolve(receipt);
          }
        } catch (error) {
          clearInterval(interval);
          reject(error);
        }
      }, 1000); // Poll every second
    });
  };


export const convertPriceToEther = (price) => {
  return ethers.utils.parseEther(Number(price).toFixed(8))._hex;
};

export const convertHexToString = (hex) => {
  return Web3.utils.hexToNumberString(hex);
};

export const convertNumberToHex = (number) => {
  return Web3.utils.numberToHex(Number(number));
};
